module.exports = "/_next/static/images/37132001a9ea6b66beadd1148790766b-man-looking-up-smiling-xs@2x.jpg";